//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AreaChart from "../Charts/AreaChart.vue";
import PieChart from "../Charts/PieChart.vue";
import BarChart from "../Charts/BarChart.vue";
import LineChart from "../Charts/LineChart.vue";

export default {
  components: {
    AreaChart,
    PieChart,
    BarChart,
    LineChart,
  },
  data() {
    return {};
  },
};
